import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { AgreementDetails, AgreementsApi } from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import { ContractAgreement } from '../models/contract-agreement.model';
import { AgreementApiPort } from '../ports/agreement-api.port';

@Injectable()
export class AdessoContractAgreementApiAdapter extends AgreementApiPort {
  private readonly api = new AgreementsApi(inject(ADESSO_API_CONFIG));

  getContractAgreements(): Observable<ContractAgreement[]> {
    return from(this.api.getAllAgreements()).pipe(
      map((res) => (res.data ?? []).map(toDomain))
    );
  }

  getContractAgreementById(id: string): Observable<ContractAgreement> {
    return from(this.api.getAgreement(id)).pipe(map((res) => toDomain(res.data)));
  }
}

function toDomain(dto: AgreementDetails): ContractAgreement {
  return {
    id: dto.agreementId ?? '',
    assetId: dto.assetId ?? '',
    consumerId: dto.consumerId ?? '',
    providerId: dto.providerId ?? '',
    contractSigningDate: dto.contractSigningDate ?? 0,
    policy: parsePolicyJsonLd(dto.policyJsonLd)
  };
}

function parsePolicyJsonLd(raw: string | undefined): Record<string, unknown> {
  if (!raw) return {};
  try {
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}
